import { areItemsEqual } from '.';
export default (function (_ref) {
  var selectedItems = _ref.selectedItems,
      item = _ref.item;
  return selectedItems ? selectedItems.some(function (selectedItem) {
    return areItemsEqual(selectedItem, item);
  }) : false;
});
//# sourceMappingURL=isItemSelected.js.map